import { createContext, useContext, useMemo } from 'react';

import { createPlatformBridge } from '../../../core/bridge/platform';
import { embedConfig } from '../../config/embed';

const DeviceContext = createContext(null);

// One bridge per app instance. It is intentionally not disposed on unmount:
// StrictMode's mount/unmount/mount would leave a dead instance behind. The
// bridge holds no idle listeners; callers abort their own requests instead.
export function DeviceProvider({ children }) {
    const value = useMemo(() => {
        const bridge = createPlatformBridge({ embedHostOrigin: embedConfig.hostOrigin });
        return {
            bridge,
            embed: embedConfig,
            isNative: bridge.host === 'capacitor' || bridge.host === 'webkit',
            isEmbedded: embedConfig.isEmbed,
        };
    }, []);

    return <DeviceContext.Provider value={value}>{children}</DeviceContext.Provider>;
}

export function useDevice() {
    const context = useContext(DeviceContext);
    if (!context) throw new Error('useDevice must be used inside <DeviceProvider>');
    return context;
}
